import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import '/src/assets/css/base-1.css'
import '/src/assets/css/base-2.css'
import '/src/assets/css/base-3.css'
import '/src/assets/css/base-4.css'
import '/src/assets/css/base-5.css'
import '/src/assets/css/base-6.css'
import '/src/assets/css/base-7.css'
import '/src/assets/css/base-8.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'


const app = createApp(App).use(router)
app.use(ElementPlus)
app.use(router)
app.mount('#app')